// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-notification[data-v-2ce05007]{padding:0}.custom-template-container[data-v-2ce05007]{display:flex;opacity:.8}.custom-template-content[data-v-2ce05007]{padding:10px;flex-basis:200px;text-align:center}.custom-template-text[data-v-2ce05007]{font-size:.6em}.custom-template-close[data-v-2ce05007]{border:none;border-left:1px solid #ddd;padding:10px;flex-basis:5em;color:red;text-align:center;cursor:pointer;cursor:hand}", ""]);
// Exports
module.exports = exports;
